import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { StyledTeamActionButton } from "./styles";

type Props = {
    name: string | null | undefined;
    description: string | null | undefined;
    onEdit: () => void;
    onDelete: () => void;
};

export const TeamDetailHeader = ({ name, description, onEdit, onDelete }: Props) => {
    const { translate } = useTranslate();

    return (
        <Flex
            justifyContent="space-between"
            alignItems="center"
            gap="16px"
        >
            <Stack gap="10px">
                <Flex
                    alignItems="center"
                    gap="8px"
                >
                    <Text
                        fontVariant="h2"
                        color={colorsPalettes.carbon["400"]}
                        data-automation="team-detail-name"
                    >
                        {name ?? translate("si.management.teams.detail.title")}
                    </Text>
                    <Tooltip
                        placement="top"
                        content={translate("si.management.teams.detail.edit_button.tooltip")}
                    >
                        <StyledTeamActionButton
                            type="flat"
                            iconSize="xs"
                            iconName="edit-icon-fill"
                            onClick={onEdit}
                            dataAutomation="team-detail-edit-button"
                        />
                    </Tooltip>
                </Flex>
                {description ? (
                    <Text
                        fontVariant="body1"
                        color={colorsPalettes.carbon["300"]}
                        data-automation="team-detail-description"
                    >
                        {description}
                    </Text>
                ) : null}
            </Stack>
            <Tooltip
                placement="top"
                content={translate("si.management.teams.detail.delete_button.tooltip")}
            >
                <StyledTeamActionButton
                    type="flat"
                    iconSize="xs"
                    iconName="delete"
                    onClick={onDelete}
                    dataAutomation="team-detail-delete-button"
                />
            </Tooltip>
        </Flex>
    );
};
